import './AccessibilityChecker.less';

import React, { useEffect, useState } from 'react';
import config from '@plone/volto/registry';
import find from 'lodash/find';
import { useSelector } from 'react-redux';

import AmawebValidator from './components/AmaWebValidator';
import AxeCoreValidator from './components/AxeCoreValidator';
import { ensureErrorVisibility, parseBooleanFlag } from './helpers';

const AccessibilityChecker = ({ location }) => {
  const pathname = location.pathname;
  const isEdit = pathname.endsWith('/edit') || pathname.endsWith('/add');
  const [isClient, setIsClient] = useState(false);

  const token = useSelector((state) => state.userSession?.token);
  const objectActions = useSelector(
    (state) => state.actions?.actions?.object ?? {},
  );
  const userCanEdit = find(objectActions, { id: 'edit' });

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (isClient) {
    const rawHideA11y =
      (typeof window !== 'undefined' &&
      window?.env?.RAZZLE_HIDE_A11Y !== undefined
        ? window.env.RAZZLE_HIDE_A11Y
        : undefined) ?? process.env.RAZZLE_HIDE_A11Y;
    if (parseBooleanFlag(rawHideA11y)) return null;
  }

  const shouldRenderComponent =
    isClient &&
    token &&
    !config.settings.disableA11yChecker &&
    !isEdit &&
    userCanEdit;

  return shouldRenderComponent ? (
    <div className="ui container a11y-message">
      <AmawebValidator pathname={pathname} />
      <AxeCoreValidator pathname={pathname} />
    </div>
  ) : null;
};

export { ensureErrorVisibility };
export default AccessibilityChecker;
